/* TODO: t() */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';
import {
  Alert,
  Form,
  FormField,
  Label,
  SubmitButton,
  TextInput,
} from '../uiold';

import { postJSON } from '../../support/Fetch';
import AdminModal from './AdminModal';

type Props = {
  email: string;
  marketAccountID: string;
  setEmail: (value: string) => void;
  displayRegistrationModal: () => void;
  displayPasswordModal: () => void;
  onHide: () => void;
};

export default function LoginModal(props: Props) {
  const {
    displayRegistrationModal,
    email,
    marketAccountID,
    onHide,
    setEmail,
    displayPasswordModal,
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<null | string>(null);

  const checkEmailRegistration = () => {
    setIsLoading(true);
    postJSON(
      '/api/vendors/by-email/status',
      { orgId: marketAccountID, email },
      (error, data) => {
        if (error) {
          setError('Something went wrong');
          return;
        }
        switch (data.status) {
          case 'registered': {
            onHide();
            displayPasswordModal();
            break;
          }
          case 'not-registered': {
            onHide();
            displayRegistrationModal();
            break;
          }
          default: {
            setError('No account found with that email address');
          }
        }
      },
    );
    setIsLoading(false);
  };

  const renderError = () => {
    if (!error) {
      return null;
    }
    return (
      <Alert
        allowResize
        type="error"
        onDismiss={() => setError(null)}
        style={styles.errorAlert}
        text={error}
      />
    );
  };

  return (
    <AdminModal
      title="Log In / Register"
      isLoading={isLoading}
      onClose={() => onHide()}
    >
      <Form onSubmit={checkEmailRegistration} style={styles.alignStretch}>
        {renderError()}
        <FormField
          render={(id) => (
            <View>
              <Label style={styles.textLabel} htmlFor={id}>
                Email:
              </Label>
              <TextInput
                keyboardType="email-address"
                id={id}
                autoFocus
                style={styles.textInput}
                value={email}
                onChangeText={(value) => setEmail(value)}
              />
            </View>
          )}
        />
        <View style={styles.buttonContainer}>
          <SubmitButton title="Next" />
        </View>
      </Form>
    </AdminModal>
  );
}

let styles = StyleSheet.create({
  alignStretch: {
    alignSelf: 'stretch',
  },
  textLabel: {
    fontSize: 14,
    marginTop: 10,
  },
  textInput: {
    marginVertical: 5,
  },
  buttonContainer: {
    paddingVertical: 20,
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  errorAlert: {
    marginBottom: 10,
  },
});
